/**
 * Returns the avatar url for a steam avatar hash
 * @param avatarHash The hash
 * @param size Size of the image: 0 = smallest, 1 = medium, 2 = full
 */
export function steamAvatarUrl(avatarHash: string, size?: number) {
    return `https://avatars.steamstatic.com/${avatarHash}${(size === 1 ? '_medium' : size === 2 ? '_full' : '')}.jpg`
}

export const DEFAULT_STEAM_AVATAR_URL = "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/b5/b5bd56c1aa4644a474a2e4972be27ef9e82e517e_medium.jpg"